import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./AccountIndex'),
  loading: () => <Loading />,
});

export const Form = Loadable({
  loader: () => import('./AccountFormPage'),
  loading: () => <Loading />,
});

export const ForgotPassword = Loadable({
  loader: () => import('./ForgotPasswordPage'),
  loading: () => <Loading />,
});

export const ResetPassword = Loadable({
  loader: () => import('./ResetPasswordPage'),
  loading: () => <Loading />,
});

export const PasswordResetConfirmation = Loadable({
  loader: () => import('./PasswordResetConfirmationPage'),
  loading: () => <Loading />,
});
